import CmlRateHeaderIndex from "@/components/billing_cml/rate/header/RateHeaderIndex.vue";
import CmlRateHeaderAdd from "@/components/billing_cml/rate/header/RateHeaderAdd.vue";
import CmlRateHeaderDetail from "@/components/billing_cml/rate/header/RateHeaderDetail.vue";
import CmlRateHeaderEdit from "@/components/billing_cml/rate/header/RateHeaderEdit.vue";
import CmlRateDetailHandlingIndex from "@/components/billing_cml/rate/detail-handling/RateDetailHandlingIndex.vue";
import CmlRateDetailStorageIndex from "@/components/billing_cml/rate/detail-storage/RateDetailStorageIndex.vue";
import CmlRateDetailSubStorageIndex from "@/components/billing_cml/rate/detail-sub-storage/RateDetailSubStorageIndex.vue";
import CmlRateDetailSubHandlingIndex from "@/components/billing_cml/rate/detail-sub-handling/RateDetailSubHandlingIndex.vue";

let routesRateAccess = [
  {
    path: "header",
    meta: {
      title: "CML Rate Header",
    },
    name: "CmlRateHeaderIndex",
    component: CmlRateHeaderIndex,
  },
  {
    path: "header/create",
    meta: {
      title: "CML Create Rate Header",
    },
    name: "CmlRateHeaderAdd",
    component: CmlRateHeaderAdd,
  },

  {
    path: "header/detail/:id",
    meta: {
      title: "CML Detail Rate Header",
    },
    name: "CmlRateHeaderDetail",
    component: CmlRateHeaderDetail,
  },

  {
    path: "header/edit/:id",
    meta: {
      title: "CML Edit Rate Header",
    },
    name: "CmlRateHeaderEdit",
    component: CmlRateHeaderEdit,
  },

  {
    path: "detail-handling/:id",
    meta: {
      title: "CML Rate Detail Handling",
    },
    name: "CmlRateDetailHandlingIndex",
    component: CmlRateDetailHandlingIndex,
  },

  {
    path: "detail-storage/:id",
    meta: {
      title: "CML Rate Detail Storage",
    },
    name: "CmlRateDetailStorageIndex",
    component: CmlRateDetailStorageIndex,
  },

  {
    path: "detail-sub-storage/:id",
    meta: {
      title: "CML Rate Detail Storage",
    },
    name: "CmlRateDetailSubStorageIndex",
    component: CmlRateDetailSubStorageIndex,
  },
  {
    path: "detail-sub-handling/:id",
    meta: {
      title: "CML Rate Detail Handling",
    },
    name: "CmlRateDetailSubHandlingIndex",
    component: CmlRateDetailSubHandlingIndex,
  },
];

export default routesRateAccess;
